import { useCallback, useContext, useMemo, useState } from "react";
import { GlobalConfigContext } from "../../../../context/GlobalConfigContext";
import { parseGraphQLError } from "../../../../utils/commons";
import { useUpdatePartnerCodeGroupMutation } from "../../Hooks/useEditPartnerCodeGroupMutation";
import PartnerCodeGroupFormModal from "../PartnerCodeGroupForm/PartnerCodeGroupForm";

function EditPartnerCodeGroupModel({
  isOpen,
  closeCreatePartnerCodeGroupModal,
  setToast,
  partnerCodeGroup,
  refetch,
}) {
  const [partnerCodeGroupData, setPartnerCodeGroupData] = useState(partnerCodeGroup);
  const [updatePartnerCodeGroupMutation, { loading }] =
    useUpdatePartnerCodeGroupMutation();

  const { programMarketConfig } = useContext(GlobalConfigContext);
  const isEditAllowed = useMemo(
    () => programMarketConfig?.isAssociatedPartnerEditable || false,
    [programMarketConfig?.isAssociatedPartnerEditable]
  );

  const handleComplete = useCallback(() => {
    setToast({
      open: true,
      type: "success",
      title: `Code Group ${partnerCodeGroupData.name} Updated!`,
      description: "You have just updated a partner Group!",
    });
    setPartnerCodeGroupData(partnerCodeGroup);
    closeCreatePartnerCodeGroupModal();
    refetch();
  }, [
    closeCreatePartnerCodeGroupModal,
    partnerCodeGroup,
    partnerCodeGroupData.name,
    refetch,
    setToast,
  ]);

  const handleUpdatePartnerCodeGroup = useCallback(
    async (data) => {
      const dataToUse = data || partnerCodeGroupData;
      /* eslint-disable no-unused-vars */
      const {
        id,
        programId,
        codeCount,
        exhaustedCode,
        importedDate,
        isImported,
        status,
        processingStatus,
        isAttached,
        uniqueCodeCount,
        allocationCount,
        maxAllocation,
        rewardItemFileData,
        ...dataToSubmit
      } = dataToUse;

      return new Promise((resolve) => {
        const onSuccess = (entity) => resolve(entity);
        const onFailure = (error) => {
          const errorMessage = parseGraphQLError(error);
          setToast({
            open: true,
            type: "error",
            title: `Could not update Partner Code Group: ${dataToUse.name}`,
            description: errorMessage,
          });
          setPartnerCodeGroupData(partnerCodeGroup);
          closeCreatePartnerCodeGroupModal();
          resolve(null);
        };

        updatePartnerCodeGroupMutation(
          onSuccess,
          onFailure,
          dataToSubmit,
          id,
          isEditAllowed
        );
      });
    },
    [
      closeCreatePartnerCodeGroupModal,
      isEditAllowed,
      partnerCodeGroup,
      partnerCodeGroupData,
      setToast,
      updatePartnerCodeGroupMutation,
    ]
  );

  return (
    <PartnerCodeGroupFormModal
      isOpen={isOpen}
      toggleCreatePartnerCodeModal={closeCreatePartnerCodeGroupModal}
      closeModal={closeCreatePartnerCodeGroupModal}
      partnerCodeGroupData={partnerCodeGroupData}
      setPartnerCodeGroupData={setPartnerCodeGroupData}
      handleMutation={handleUpdatePartnerCodeGroup}
      handleComplete={handleComplete}
      loading={loading}
      title="Edit"
      isEditMode={true}
      showToggle={true}
      readonly={partnerCodeGroup.status === "ACTIVE"}
    />
  );
}

export default EditPartnerCodeGroupModel;
